import { type TranslationTree } from '@/i18n/types';

export const messages = {
  altDefault: 'Avatar',
  invalidFile: 'Envie uma imagem em PNG, JPG ou WebP.',
} satisfies TranslationTree;
